export default function Pricing() {
  const plans = [
    {
      name: 'Basic',
      badge: '24HR',
      price: '$19',
      period: 'per photo',
      features: [
        'Standard turnaround (24 hours)',
        'One design style',
        'High-resolution images',
        'Basic furniture placement',
        'Simple item removal',
        'Email support'
      ],
      buttonText: 'Get Started',
      buttonStyle: 'border-2 border-black text-black hover:bg-black hover:text-white',
      popular: false,
      accentColor: 'border-t-[#FF6B6B]'
    },
    {
      name: 'Professional',
      badge: 'MOST POPULAR',
      price: '$49',
      period: 'per image',
      features: [
        'Express turnaround (12 hours)',
        'Multiple design styles',
        'Ultra high-resolution images',
        'Advanced furniture & decor',
        'Advanced furniture removal',
        'Clutter & item removal',
        'Unlimited revisions',
        'Priority support'
      ],
      buttonText: 'Get Started →',
      buttonStyle: 'bg-black text-white hover:bg-gray-800',
      popular: true,
      accentColor: ''
    },
    {
      name: 'Enterprise',
      badge: 'CUSTOM',
      price: 'Custom',
      period: 'pricing',
      features: [
        'Rush delivery (12 hours)',
        'Dedicated account manager',
        'Custom design consultation',
        'Complex furniture removal',
        'Bulk removal & staging',
        'Bulk pricing discounts',
        '24/7 phone support'
      ],
      buttonText: 'Contact Sales',
      buttonStyle: 'border-2 border-black text-black hover:bg-black hover:text-white',
      popular: false,
      accentColor: 'border-t-purple-500'
    }
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="py-24 bg-gradient-to-br from-purple-50 to-pink-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4">Transparent Pricing</h2>
          <p className="text-lg text-gray-600">Choose the plan that fits your needs</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`rounded-3xl p-8 transition-all duration-300 ${
                plan.popular
                  ? 'bg-gradient-to-br from-[#FF6B6B] to-[#FF8E8E] text-white shadow-2xl scale-105'
                  : `bg-white ${plan.accentColor} border-t-4`
              } hover:shadow-xl`}
            >
              <div className="mb-6">
                <div className="flex items-center justify-between mb-4">
                  <span className={`text-xs font-bold tracking-wider ${plan.popular ? 'text-white' : 'text-gray-500'}`}>
                    {plan.badge}
                  </span>
                  {plan.popular && (
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className="ri-arrow-right-up-line text-2xl"></i>
                    </div>
                  )}
                </div>
                <h3 className={`text-2xl font-bold mb-2 ${plan.popular ? 'text-white' : 'text-black'}`}>
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-2">
                  <span className={`text-5xl font-bold ${plan.popular ? 'text-white' : 'text-black'}`}>
                    {plan.price}
                  </span>
                  <span className={`text-sm ${plan.popular ? 'text-white/80' : 'text-gray-500'}`}>
                    {plan.period}
                  </span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className={`ri-check-line text-xl flex-shrink-0 ${plan.popular ? 'text-white' : 'text-[#FF6B6B]'}`}></i>
                    <span className={`text-sm ${plan.popular ? 'text-white' : 'text-gray-700'}`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => scrollToSection('contact')}
                className={`w-full py-4 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer ${plan.buttonStyle}`}
              >
                {plan.buttonText}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}